export class DateFormatter {
    // You can define your desired date format here
    private formatString: string = 'DD-MM-YYYY';

    format(dateString: string): string {
        let result: string = '';

        if (dateString != null) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = this.padNumber(date.getMonth() + 1); // Months are 0-based
            const day = this.padNumber(date.getDate());

            result = this.formatString.replace('YYYY', year.toString()).replace('MM', month).replace('DD', day);
        }

        return result;
    }

    private padNumber(number: number): string {
        return number < 10 ? '0' + number : number.toString();
    }
}

export class DateTimeFormatter {
    formatDateTime(dateString: string): string {
        const date = new Date(dateString);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? 0 + minutes : minutes;
        const strTime = hours + ':' + minutes + ' ' + ampm;

        return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
    }
}

export class DateFormatterReverse {
    // You can define your desired date format here
    private formatString: string = 'YYYY-MM-DD';

    format(dateString: string): string {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = this.padNumber(date.getMonth() + 1); // Months are 0-based
        const day = this.padNumber(date.getDate());

        return this.formatString.replace('YYYY', year.toString()).replace('MM', month).replace('DD', day);
    }

    private padNumber(number: number): string {
        return number < 10 ? '0' + number : number.toString();
    }
}

export class JobNumberFormatter {
    format(refNum: number): string {
        return this.padNumber(refNum);
    }

    private padNumber(number: number): string {
        if (number < 10) {
            return 'J00' + number;
        } else if (number < 100) {
            return 'J0' + number;
        } else {
            return 'J' + number;
        }
    }
}

export class QuoteNumberFormatter {
    format(refNum: number): string {
        return this.padNumber(refNum);
    }

    private padNumber(number: number): string {
        if (number < 10) {
            return 'Q00' + number;
        } else if (number < 100) {
            return 'Q0' + number;
        } else {
            return 'Q' + number;
        }
    }
}

export class StripCaseNumber {
    format(refNum: string): number {
        return this.stripNumber(refNum);
    }

    private stripNumber(refNum: string): number {
        const numStr = refNum.replace(/^C0*/, ''); // Remove 'C' or 'C0' or 'C00' from the beginning
        return parseInt(numStr, 10); // Convert the remaining string to a number
    }
}

export class ErrorLogger {
    static Log(err: string) {
        console.log((JSON.stringify(err, null, 2)));
    }
}